import { ChangeDetectionStrategy, Component, Input, output, inject, input } from '@angular/core';

import { ActivitySubscriptionType } from '@core/activities-types';
import type { ActivitySubscriptions, ActivitySubscriptionUpdateData } from '@core/activities-types';
import { FeatureSpecFacade } from '@core/feature-spec-logic';
import { FeatureCode } from '@core/feature-spec-types';
import { GdprService } from '@core/gdpr-logic';
import { I18nService, TranslatePipe } from '@core/i18n-legacy';

import { ActivitySubscriptionsTableRowComponent } from '../activity-subscriptions-table/activity-subscriptions-table-row/activity-subscriptions-table-row.component';
import { ActivitySubscriptionsTableComponent } from '../activity-subscriptions-table/activity-subscriptions-table.component';

@Component({
  selector: 'rt-activity-subscriptions-followed-by-me-offer',
  templateUrl: './activity-subscriptions-followed-by-me-offer.component.html',
  styleUrls: ['../activity-subscriptions.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ActivitySubscriptionsTableComponent,
    ActivitySubscriptionsTableRowComponent,
    TranslatePipe,
  ],
})
export class ActivitySubscriptionsFollowedByMeOfferComponent {
  private readonly i18n = inject(I18nService);
  private readonly featureSpecDataHelpers = inject(FeatureSpecFacade);
  public readonly gdprSvc = inject(GdprService);

  @Input()
  public set types(types: ActivitySubscriptionType[]) {
    this.title = types.includes(ActivitySubscriptionType.Slack)
      ? this.i18n.translate('app.subscriptions.followed_by_me_offer_slack')
      : this.i18n.translate('app.subscriptions.followed_by_me_offer');
    this._types = types;
  }

  public get types(): ActivitySubscriptionType[] {
    return this._types;
  }

  public readonly activitySubscriptions = input<ActivitySubscriptions>(undefined!);
  public readonly hasOverdueCandidates = input<boolean>(true);
  public readonly hasRequisitions = input<boolean>(false);
  @Input() public abilities = {
    viewOffers: false,
    viewCandidates: false,
    manageCandidates: false,
    viewRequisitions: false,
  };

  public changeEvents = output<ActivitySubscriptionUpdateData>();

  public title: string;

  public isScreeningAssistantEnabled = this.featureSpecDataHelpers.selectIsEnabled(
    FeatureCode.AiCandidateScreening,
  );

  private _types: ActivitySubscriptionType[];
}
